"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ImageAndTextSplit() {
  const {
    ref: textRef,
    isVisible: textIsVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageIsVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return;
}